<template>
   <div class="pdf-main">
     <div class="pdfBody">
       <iframe v-if="pdfUrl!==''" :src="pdfUrl" width="100%" height="800vh" :key="pdfUrl"></iframe>
     </div>
   </div>
</template>
<script>
import global from "../../utils/global";
import {getZsUrl} from "../../http/moudules/dwzs";

export default {
  // 单位证书和人员证书验证
  name: "ZsYz",
  data(){
     return {
        pdfUrl:'',
        baseUrl: global.baseUrl,
     }
  },
  mounted() {
    this.getPdfUrl()
  },
  methods:{
    getPdfUrl(){
      const id = this.$route.query.id
      const type = this.$route.query.type
      this.pdfUrl = ''
      getZsUrl({id:id,type:type}).then(result=>{
          if(result.code === 200){
            const secondDir = this.baseUrl;
            const src = secondDir + '/' + result.data;
            const encodedFile = encodeURIComponent(src);
            this.pdfUrl = `./static/pdf/web/viewer.html?file=${encodedFile}?_t=${Date.now()}`;
          }else {
            this.$message.error(result.message)
          }
      }).catch(()=>{
        this.$message.error("获取证书失败")
      })
    }
  }
}
</script>
<style scoped>
.pdf-main{
   width: 100%;
   height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Member/ZsYz.vue